module.exports = "/lucky-balls/img/drum/drum_loop_034.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_034.png
// module id = 1049
// module chunks = 0